module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-kpito-02.2c30f814.jpg";